import { useSelector } from '../../../_shared/utils/hooks/useSelector';
import { type AppState } from '../../app.store';

const mapSettingsToolsStateSelector = (state: AppState) => state.map.mapSettings.data.toolsState;
export const useMapSettingsToolsStateSelector = () => useSelector(mapSettingsToolsStateSelector);
